import { useParams } from 'react-router'
import { useUserLinkedProjects } from './useUserLinkedProjects'

export function useCurrentProject() {
  const params = useParams()
  const projectId = Number(params.projectId)
  const projects = useUserLinkedProjects()
  const project = projects.find((x) => x.projectId === projectId)

  if (!project) {
    throw new Error('Project not found')
  }

  return project
}
